import React from 'react';
import { Link, useLocation, Outlet } from 'react-router-dom';
import { LayoutDashboard, FolderOpen, Tag, User, Mail, MessageSquare, LogOut, BarChart3 } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const AdminLayout = () => {
  const location = useLocation();
  const { logout } = useAuth();

  const menuItems = [
    { path: '/admin/dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { path: '/admin/projects', label: 'Projects', icon: FolderOpen },
    { path: '/admin/categories', label: 'Categories', icon: Tag },
    { path: '/admin/analytics', label: 'Analytics', icon: BarChart3 },
    { path: '/admin/messages', label: 'Messages', icon: MessageSquare },
    { path: '/admin/about', label: 'About', icon: User },
    { path: '/admin/contact', label: 'Contact', icon: Mail }
  ];

  const handleLogout = () => {
    logout();
    window.location.href = '/admin/login';
  };

  return (
    <div className="min-h-screen flex" data-testid="admin-layout">
      <aside className="fixed left-0 top-0 h-full w-64 border-r border-white/10 bg-black/95 backdrop-blur-md z-50" data-testid="admin-sidebar">
        <div className="p-6">
          <Link to="/" className="text-2xl font-bold font-['Syne']" data-testid="admin-logo">
            Debojit Admin
          </Link>
        </div>
        
        <nav className="px-4 space-y-2" data-testid="admin-nav">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-4 py-3 rounded-md transition-colors ${
                  isActive
                    ? 'bg-primary text-black font-medium'
                    : 'text-white/80 hover:bg-white/5'
                }`}
                data-testid={`admin-nav-${item.label.toLowerCase()}`}
              >
                <Icon size={20} />
                {item.label}
              </Link>
            );
          })}
        </nav>

        <div className="absolute bottom-6 left-4 right-4">
          <button
            onClick={handleLogout}
            className="flex items-center gap-3 px-4 py-3 rounded-md text-white/80 hover:bg-white/5 transition-colors w-full"
            data-testid="admin-logout-button"
          >
            <LogOut size={20} />
            Logout
          </button>
        </div>
      </aside>

      <main className="ml-64 flex-1 p-8" data-testid="admin-content">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
